export default function FundraiseUpForm({ action, onSubmit }) {
  
  if (typeof FundraiseUp !== 'undefined') {
    FundraiseUp.on('checkoutOpen', function(details) {
      onSubmit();
    });  
  }
  
  return <div className="fundraise-up-form">
    <div dangerouslySetInnerHTML={{ __html: action?.config?.elementCode }} />
  </div>
}
